/** Quyền hệ thống — khớp PermissionEnum trên backend */
export enum PermissonEnum {
    ///Xem
    Read = 1,
    ///Tạo
    Create = 2,
    ///Sửa
    Update = 4,
    ///Xóa
    Delete = 8,
    ///Biên tập
    Editing = 16,
    ///Duyệt nội dung y khoa
    Medical = 32,
    ///Quyền lãnh đạo
    Manage = 64,
    ///Cài đặt
    Setting = 1024,
    ///Toàn quyền chức năng
    Full = 1073741824,
    ///None
    Allow = 34359738368,
}

/** Module hệ thống — khớp ModuleEnum trên backend */
export enum ModuleEnum {
    ///Quản lý sở
    Department = 1,
    ///Quản lý trường
    School = 3,
    ///Quản lý năm học
    AcademicYear = 4,
    ///Quản lý câu hỏi
    Question = 5,
    ///Quản lý đề thi
    Exam = 6,
    ///Quản lý danh mục
    Category = 7,
    ///Quản lý tin tức
    News = 8,
    Gallery = 9,
    ///Quản lý sản phẩm
    Product = 10,
    ///Quản lý đơn hàng
    Order = 12,
    ///Lớp học
    Class = 16,
    ///Quản lý đăng ký tư vấn
    ConsultationRegistration = 17,
    ///Tracking & tích điểm
    Tracking = 18,
    ///Quản lý liên hệ
    Contact = 13,
    ///Quản lý trang tĩnh
    StaticPage = 14,
    ///Quản lý đa ngôn ngữ
    Translation = 15,
    ///Cấu hình hệ thống
    SystemConfig = 19,
    ///Quản lý tên cấm
    UserIdentifier = 20,
    ///Quản lý nhóm người dùng
    Role = 98,
    ///Quản lý người dùng
    User = 99,
    ///Cơ cấu phòng ban nội bộ trường/tổ chức
    Departments = 21,
    ///Quyền sở hữu trường/tổ chức
    SchoolOwnership = 22,
    ///Thông báo thủ công
    Announcement = 23,
    ///Kho game (quản trị kho game hệ thống)
    GameStore = 24,
}
